export const Pdf = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9l-6-6z"
      fill="black"
      fillOpacity="0.56"
    />
    <path d="M13 3v6h6" fill="none" stroke="white" strokeWidth="2" />
  </svg>
);
